import * as React from "react";
import { Outlet, HeadContent } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { useLocale, useSyncI18nLocale } from "@/hooks/useLocale";

/**
 * Root Layout Component
 *
 * This is the root layout for the entire application.
 * It wraps all pages with:
 * - Toaster: Toast notifications (sonner)
 * - HeadContent: Renders per-route <title>, <meta>, <link> tags
 *
 * It also syncs i18next with the URL-derived locale so language follows
 * navigation (e.g. moving between / and /fr/...).
 */
export function RootLayout() {
  const locale = useLocale();
  useSyncI18nLocale(locale);

  return (
    <>
      {/* Per-route document head tags (title/meta/link) */}
      <HeadContent />

      {/* Main content outlet */}
      <Outlet />

      {/* Global toast notifications */}
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}
